import { buildSkillStep } from "@/core/skillForms/builder";

export const createContractSkillStep1 = buildSkillStep({
  title: "Tipo de contrato",
  description: "Para começar, defina o tipo de contrato a ser elaborado utilizando de inteligência artificial.",
  fields: [
    {
      name: "contract_micro_type",
      type: "string",
      ui: {
        label: "Qual é o tipo do contrato?",
        placeholder: "Exemplo: Contrato de aluguel",
      },
    },
  ],
});
